const HIGH_CONTRAST_COOKIE = 'high-contrast';

function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
}

function getCookie(name) {
  return document.cookie.split('; ').reduce((acc, part) => {
    const [key, val] = part.split('=');
    return key === name ? val : acc;
  }, null);
}

function updateLabel(enabled) {
  const span = document.querySelector('#toggle-contrast span');
  if (span) span.textContent = enabled ? 'aan' : 'uit';
}

// Apply on page load
const initialState = getCookie(HIGH_CONTRAST_COOKIE) === '1';
if (initialState) {
  document.body.classList.add('high-contrast');
}
updateLabel(initialState);

document.getElementById('toggle-contrast')?.addEventListener('click', () => {
  const enabled = document.body.classList.toggle('high-contrast');
  setCookie(HIGH_CONTRAST_COOKIE, enabled ? '1' : '0', 365);
  updateLabel(enabled);
});
